import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { ValidationErrorBoundary } from "./components/ValidationErrorBoundary";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

/* global document, Office, module, require */

const title = "ContraVault for Outlook";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  // Hide initial loader
  const loader = document.getElementById("initial-loader");
  if (loader) {
    loader.style.display = "none";
  }

  root?.render(
    <FluentProvider theme={webLightTheme}>
      <ValidationErrorBoundary>
        <App title={title} />
      </ValidationErrorBoundary>
    </FluentProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(
      <FluentProvider theme={webLightTheme}>
        <NextApp title={title} />
      </FluentProvider>
    );
  });
}
